import React, { useEffect, useState } from "react";
import Checkbox from "../common/form/Checkbox";
import TodoDetails from "./TodoDetails";

export default function TodoItem({
  todo,
  handleExpireTodo,
  handleUpdateTodoCompleted,
  sample_id,
}) {
  const [showDetails, setShowDetails] = useState(false);

  function toggleDetails() {
    setShowDetails(!showDetails);
  }

  return (
    <li className="todo" style={{}}>
      <div className="todo-main">
        <label className="todo-checkbox">
          <Checkbox
            checked={todo.completed}
            onChange={() => {
              handleUpdateTodoCompleted(todo.id);
            }}
          />
        </label>
        <label
          className="todo-body"
          style={{
            textDecoration: todo.completed ? "line-through" : "none",
            paddingLeft: 9,
          }}
        >
          {todo.body}

          {todo.topic_name && (
            <label
              style={{ backgroundColor: todo.topic_colour, marginRight: 10 }}
              className="label label-default pull-right"
            >
              {todo.topic_name}
            </label>
          )}
        </label>
        <div style={{ paddingTop: 3 }}>
          <button
            onClick={toggleDetails}
            className="btn btn-default btn-xs"
            style={{ marginBottom: 0, marginLeft: 8 }}
          >
            <i className="fa fa-bars" />
          </button>
        </div>
      </div>
      {showDetails && (
        <div>
          <TodoDetails todo={todo} sample_id={sample_id} handleExpireTodo={handleExpireTodo} />
        </div>
      )}
    </li>
  );
}
